/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import { ChipCshcnRateAuditTableHead } from './TableHead';

import Spinner from '../../../../SharedModules/Spinner/Spinner';

export default function DispChipCshcnRateAudit() {
  const dispatch = useDispatch();
  const [resultList, setResultList] = React.useState([]);
  const {
    isLoading,
    rebateProgramValue,
    rebateProgramList,
    searchResult,
    rebateProgrameName,
    manufacturerSelected,
    quarterValue,

    selectedPlanType,
  } = useSelector((state) => state?.sharedState?.ChipCshcnRateAuditReducer);
  // TO get the complete name of the rebate program
  const rebateProgramNameValue = rebateProgrameName;
  //   rebateProgramList.find(
  //     (item) => item.rebateProgramCd === rebateProgramValue
  //   ) || '';
  // rebateProgramNameValue = `${rebateProgramNameValue?.rebateProgramCd} - ${
  //   rebateProgramNameValue?.shortDescr || ''
  // }`;

  React.useEffect(() => {
    let updatedSearchResult = searchResult || [];
    updatedSearchResult = updatedSearchResult?.map((item) => {
      const ndcValue = `${item.labelerCode} - ${item.productCode} - ${item.packageSize}`;
      return {
        ...item,
        ndc: ndcValue,
        amp: item.amp ? item.amp : '0.00',
        bp: item.bp ? item.bp : '0.00',
        calcUra: item.calcUra ? item.calcUra.toFixed(4) : '0.0000',
      };
    });
    setResultList(updatedSearchResult);
  }, [searchResult]);

  const [fullScreenView, setfullScreenView] = React.useState(false);
  const handleFullScreenView = () => {
    setfullScreenView(!fullScreenView);
  };
  const firstInfo = `Quarter : ${quarterValue}`;
  const thirdInfo = `${rebateProgramNameValue}`;
  return (
    <div className="tabs-container">
      {!fullScreenView && (
        <div className="tab-body custom-search-dates">
          <CustomSeparator
            parent1="State Reports"
            parent2="Display CHIP/CSHCN Rate Audit"
          />
          <Spinner load={isLoading} />
          <div className="mui-custom-form input-md field-xl">
            <div className="row mb-2">
              <div className="col-6">
                <TextField
                  label="Rebate Program : "
                  id="Rebate Program"
                  fullWidth
                  placeholder=""
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={rebateProgramNameValue}
                  name="RebateProgram"
                  disabled
                />
              </div>
              <div className="col-6">
                <TextField
                  label="Calculated Quarter :"
                  id="Calculated Quarter"
                  fullWidth
                  placeholder=""
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={quarterValue}
                  name="quarter"
                  disabled
                />
              </div>
            </div>
          </div>
        </div>
      )}
      <TableGridWithFeatures
        suppressCellFocus
        rowData={resultList}
        columnDefs={ChipCshcnRateAuditTableHead}
        rowMultiSelectWithClick
        data-testid="onEditingStopped"
        enterMovesDown
        showResetFilter={false}
        defaultCol={{
          wrapHeaderText: true,
          autoHeaderHeight: true,
        }}
        hideTotalCount={false}
        exportFile
       // isScrollOn
        fileName="CHIP_CHSCN RATES AUDIT"
        reportName="CHIP CSHCN Rate Audit Report"
        fullScreenView={fullScreenView}
        handleFullScreenViewClick={handleFullScreenView}
        gridHeight={fullScreenView ? '100vh' : viewPortHeight_355}
        info={{ firstInfo, thirdInfo }}
      />
    </div>
  );
}
